import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Step from '../shared/Step';
import ExcursionItem from './ExcursionItem';
import { addProductToCart, removeProductFromCart } from '../../reducers/cart';
import {
  selectExcursionOption,
  deselectExcursionOption,
} from '../../reducers/form';
import API from '../../utils/api';
import GTMService from '../../utils/gtm';
import { getCampsIntervals, formatRawDate } from '../../utils/helpers';

const api = new API();
const gtm = new GTMService();

const Excursions = ({
  isVisible,
  title,
  age,
  selectedExcursionOptions,
  selectedCampOptions,
  selectExcursionOption,
  programLengthInWeeks,
  deselectExcursionOption,
  addProductToCart,
  removeProductFromCart,
}) => {
  const [excursions, setExcursions] = useState([]);
  const bundleCamps = useMemo(
    () => Object.values(selectedCampOptions).filter((o) => !!o.hasExcursions),
    [selectedCampOptions]
  );

  useEffect(() => {
    const fetchExcursions = () => {
      // XXX No excursions if customer selects a one week camp
      if (programLengthInWeeks === 1) {
        return;
      }

      // XXX Loading intervals is ignored here
      // We are going to use only first start and last end from the array
      const intervals = getCampsIntervals(Object.values(selectedCampOptions));
      console.log('intervals',intervals,selectedCampOptions);
      /*
      const startPlusOne = new Date(intervals[0].start.split('-'));
      const endMinusOne = new Date(
        intervals[intervals.length - 1].end.split('-')
      );
      */
      const startPlusOne = new Date(new Date(intervals[0].start).toLocaleString('en', {timeZone: 'UTC'}));
      const endMinusOne = new Date(new Date(intervals[intervals.length - 1].end).toLocaleString('en', {timeZone: 'UTC'}));
      startPlusOne.setDate(startPlusOne.getDate() + 1);
      endMinusOne.setDate(endMinusOne.getDate() - 1);

      api
        .fetchExcursions({
          start_date: formatRawDate(startPlusOne),
          end_date: formatRawDate(endMinusOne),
          age,
        })
        .then((res) => {
          console.log('intervals1',res);
          setExcursions(res.results);
        });

      return;
    };

    fetchExcursions();
  }, [age, programLengthInWeeks, selectedCampOptions]);

  const handleAdd = async (item, dateId) => {
    const product = item.dates.find((d) => String(d.id) === dateId);
    const res = await addProductToCart({
      type: 'excursion',
      product,
      attributes: [
        {
          bundle: false,
        },
      ],
    });

    if (res) {
      selectExcursionOption(product.id, {
        participantProductId: res.participant_product_id,
        name: product.name,
        product,
      });
      gtm.trackAddToCart(product, 'excursion');
    }
  };

  const handleRemove = async (id) => {
    await removeProductFromCart(
      selectedExcursionOptions[id].participantProductId
    );
    deselectExcursionOption(id);
  };

  if (!isVisible) {
    return null;
  }

  if (bundleCamps.length > 0) {
    return (
      <Step title="+">
        <Step.Sub title={title}>
          <div className="extras">
            <div className="extras__included-logo">
              <img
                src="//www.imgacademy.com/sites/default/files/included-item.png"
                alt="Included excursions"
              />
              <p>
                PRO TIP: One of our Camp Advisors will Follow-up with you prior
                to check-in with your available excursion options.
              </p>
            </div>
            <div className="extras__included-card">
              <div className="card-content">
                <h5>Choice of 1 Off-campus Excursion</h5>
                <img
                  src="//www.imgacademy.com/sites/default/files/excursions-set.jpg"
                  alt="included excursions"
                />
                <p>
                  Youth campers will take advantage of a chaperoned, off-campus
                  excursion and visit one of the best theme parks Florida has to
                  offer. Trips include Busch Gardens, Disney's Magic Kingdom,
                  Universal Studios Orlando, and The Tampa Bay Rays.
                </p>
              </div>
            </div>
          </div>
        </Step.Sub>
      </Step>
    );
  }

  if (excursions.length === 0) {
    return null;
  }

  return (
    <Step title="+">
      <Step.Sub title={title}>
        <div className="extras">
          <div className="extras__list">
            {excursions.map((item, index) => {
              const dateId = Object.keys(selectedExcursionOptions).find(
                (key) => !!item.dates.find((d) => d.id === Number(key))
              );

              return (
                <ExcursionItem
                  key={`${item.name}-${index}`}
                  item={item}
                  isSelected={!!dateId}
                  onAdd={(date) => handleAdd(item, date)}
                  onRemove={() => handleRemove(dateId)}
                />
              );
            })}
          </div>
        </div>
      </Step.Sub>
    </Step>
  );
};

const mapStateToProps = (state) => ({
  age: state.form.camper.age,
  selectedExcursionOptions: state.form.selectedExcursionOptions,
  selectedCampOptions: state.form.selectedCampOptions,
  programLengthInWeeks: state.form.programLengthInWeeks,
});

const mapDispatchToProps = (dispatch) => ({
  addProductToCart: (product) => dispatch(addProductToCart(product)),
  removeProductFromCart: (id) => dispatch(removeProductFromCart(id)),
  selectExcursionOption: (key, value) =>
    dispatch(selectExcursionOption(key, value)),
  deselectExcursionOption: (key) => dispatch(deselectExcursionOption(key)),
});

Excursions.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  age: PropTypes.string,
  selectedExcursionOptions: PropTypes.object.isRequired,
  selectedCampOptions: PropTypes.object.isRequired,
  programLengthInWeeks: PropTypes.number.isRequired,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  addProductToCart: PropTypes.func.isRequired,
  removeProductFromCart: PropTypes.func.isRequired,
  selectExcursionOption: PropTypes.func.isRequired,
  deselectExcursionOption: PropTypes.func.isRequired,
};

Excursions.displayName = 'Excursions';

export default connect(mapStateToProps, mapDispatchToProps)(Excursions);
